<div class="vtr-widget-quicksettings vtr-widget">
	<div class="container-fluid">
		<div class="row">
			<div class="col col-12">
				<p class="heading pb-4"
					role="text"
					id="dashboard-quick-settings-title">{{'dashboard.quickSettings.title' | translate}}
				</p>
				<div *ngIf="isMicrophoneVisible">
					<vtr-widget-switch-icon
						[iconDefinition]="'icomoon-FA-Microphone2x quicksettings-icon-microphone'"
						[isBlocked]="!(microphoneStatus.permission && microphoneStatus.available && quickSettingsWidget[0].state) || microPhoneGreyOut"
						[disable]="!(microphoneStatus.permission && microphoneStatus.available && quickSettingsWidget[0].state) || microPhoneGreyOut"
						[isLoading]="microphoneStatus.isLoading"
						[value]="microphoneStatus.status"
						[title]="'dashboard.quickSettings.microphone'"
						[switchId]="'Microphone'"
						(toggle)="onMicrophoneStatusToggle($event)">
					</vtr-widget-switch-icon>
				</div>
			</div>
		</div>

		<vtr-widget-quicksettings-note
			[microphoneStatus]="microphoneStatus"
			[isMicrophoneVisible]="isMicrophoneVisible"
			(onClick)="onPermissionNoteClick($event)">
		</vtr-widget-quicksettings-note>

		<div class="text-right text-uppercase mt-4">
			<a class="hyperlink-button m-0"
				id="qs-lnk-my-device-settings"
				attr.aria-label="qs-lnk-my-device-settings"
				routerLink="/device/device-settings">
				{{'dashboard.quickSettings.more' | translate}}
			</a>
		</div>
	</div>
</div>
